import { Stack, TextField } from '@fluentui/react';
import React from 'react';
import { TimeUser } from '../../../../../api/generated/data-contracts';

export const SystemInformation = ({ user }: { user: TimeUser }) => {
    return (
        <Stack>
            <TextField readOnly label="Azure AD" disabled value={user.azureId} />
            <TextField readOnly label="User Principal Name" disabled value={user.principalName} />
            <TextField readOnly label="Sync Source" disabled value={user.syncSource} />
        </Stack>
    );
};
